import OrderFinishedCargoOrdersUnbilledListRequest, {
  OrderFinishedCargoOrdersUnbilledListQueryParams,
} from "./order-finished-cargo-orders-unbilled-list-request";

const createQueryParams = (
  request: OrderFinishedCargoOrdersUnbilledListRequest,
): OrderFinishedCargoOrdersUnbilledListQueryParams => {
  return {
    address: request.address,
    client: request.client,
    dispatch: request.dispatch,
    driver: request.driver,
    endAddress: request.endAddress,
    externalId: request.externalId,
    humanId: request.humanId,
    isCancelled: request.isCancelled,
    limit: request.limit,
    midAddress: request.midAddress,
    offset: request.offset,
    order: request.order,
    passenger: request.passenger,
    startAddress: request.startAddress,
    startTimeSince: request.startTimeSince,
    startTimeTo: request.startTimeTo,
    taxi: request.taxi,
    lackingBillingType: request.lackingBillingType,
  };
};

const orderFinishedCargoOrdersUnbilledListRequestFactory = {
  createQueryParams,
};

export default orderFinishedCargoOrdersUnbilledListRequestFactory;
